import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Button from '../../../components/shared/Button/Button';
import Modal from '../../../components/shared/Modal/Modal';
import { IsMobile } from '../../../helpers/IsMobile';

import styles from './DeclineDisputeClose.module.scss';

const DeclineDisputeCloseModal = ({ show, onHide, handleSubmit }) => {
  const { t } = useTranslation('common');
  const modalFullScreen = IsMobile();
  const [reason, setReason] = useState(null);
  const [comments, setComments] = useState('');

  const handleFormSubmit = () => {
    handleSubmit({ decline_close_request_reason: reason, decline_close_request_comments: comments });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered fullscreen={modalFullScreen}>
      <Modal.CustomHeader closeButton>
        <Modal.Title>{t('dispute.declineRequest')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <form className={styles.bodyCont} onSubmit={handleFormSubmit}>
          <p className={classNames(styles.text, styles.heavy)}>{t('dispute.indicateReason')}</p>
          <Form.Check
            label={t('dispute.correctPaymentNotReceived')}
            value="0"
            type="radio"
            checked={reason === 0}
            onChange={(e) => setReason(+e.target.value)}
          />
          <Form.Check
            label={t('dispute.paymentStatusIncorrect')}
            value="1"
            type="radio"
            checked={reason === 1}
            onChange={(e) => setReason(+e.target.value)}
          />
          <Form.Check
            label={t('dispute.other')}
            value="2"
            type="radio"
            checked={reason === 2}
            onChange={(e) => setReason(+e.target.value)}
          />
          <p className={classNames(styles.text, styles.detailsLabel)}>{t('dispute.additionalDetailsOptional')}</p>
          <Form.Control
            onChange={(e) => setComments(e.target.value)}
            as="textarea"
            aria-label="comments_textarea"
            placeholder={t('placeholders.additionalComments')}
            className={styles.additionalComments}
          />
          <p className={styles.textNote}>{t('dispute.processingNote')}</p>
        </form>
      </Modal.Body>
      <Modal.CustomFooter>
        <div className={styles.actionCont}>
          <Button variant="primary" onClick={handleFormSubmit} type="submit" disabled={reason === null}>
            {t('submit')}
          </Button>
          <Button variant="outline-secondary" onClick={onHide}>
            {t('cancel')}
          </Button>
        </div>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default DeclineDisputeCloseModal;
